

export function createPageUrl(pageName: string) {
    return '/' + pageName.toLowerCase().replace(/ /g, '-');
}

/**
 * Get provider name based on current language
 * @param provider - Provider object with name and nameEn fields
 * @param language - Current language ('en' or 'th')
 * @returns Provider name in the appropriate language
 */
export function getProviderName(provider: { name: string; nameEn?: string | null }, language: string = 'en'): string {
  if (language === 'th') {
    return provider.name;
  }
  return provider.nameEn || provider.name;
}

/**
 * Get provider logo URL based on current language
 * @param provider - Provider object with logoUrlTh and logoUrlEn fields
 * @param language - Current language ('en' or 'th')
 * @returns Provider logo URL in the appropriate language, or null if not available
 */
export function getProviderLogoUrl(provider: { logoUrlTh?: string | null; logoUrlEn?: string | null; logo_url?: string | null }, language: string = 'en'): string | null {
  // Support both new format (logoUrlTh/logoUrlEn) and old format (logo_url)
  if (language === 'th') {
    return provider.logoUrlTh || provider.logo_url || null;
  }
  return provider.logoUrlEn || provider.logo_url || null;
}

/**
 * Get merchant name based on current language
 * Since merchants don't have nameEn field, this function attempts to translate
 * the merchant name using the translation system if available
 * @param merchant - Merchant object with name field
 * @param language - Current language ('en' or 'th')
 * @param t - Optional translation function from useLanguage hook
 * @returns Merchant name in the appropriate language
 */
export function getMerchantName(merchant: { name: string; nameEn?: string | null }, language: string = 'en', t?: (key: string) => string): string {
  // If merchant has nameEn field, use it for English
  if (merchant.nameEn && language === 'en') {
    return merchant.nameEn;
  }
  
  // If translation function is provided, try to translate the merchant name
  // This assumes merchant names might be stored as translation keys
  if (t && language === 'en') {
    const translated = t(merchant.name);
    // If translation returns something different from the key, use it
    if (translated !== merchant.name) {
      return translated;
    }
  }
  
  // Default: return the name as-is (assumed to be in Thai for 'th', or fallback for 'en')
  return merchant.name;
}